import { useState, useEffect } from 'react';
import { gridBreakpointXSmall, gridBreakpointSmall, gridBreakpointMedium, gridBreakpointLarge, gridBreakpointXLarge } from '@mediahuis/chameleon-theme-wl';
import { canUseDOM } from '../../utils';
const convertValuesObjectToArray = values => {
  const xs = values.xs;
  const sm = values.sm !== undefined ? values.sm : xs;
  const md = values.md !== undefined ? values.md : sm;
  const lg = values.lg !== undefined ? values.lg : md;
  const xl = values.xl !== undefined ? values.xl : lg;
  return [xs, sm, md, lg, xl];
};
const convertValuesToFallbackArray = values => {
  const xs = values[0];
  const sm = values[1] !== undefined ? values[1] : xs;
  const md = values[2] !== undefined ? values[2] : sm;
  const lg = values[3] !== undefined ? values[3] : md;
  const xl = values[4] !== undefined ? values[4] : lg;
  return [xs, sm, md, lg, xl];
};
const queries = {
  xs: `screen and (min-width: ${gridBreakpointXSmall})`,
  sm: `screen and (min-width: ${gridBreakpointSmall})`,
  md: `screen and (min-width: ${gridBreakpointMedium})`,
  lg: `screen and (min-width: ${gridBreakpointLarge})`,
  xl: `screen and (min-width: ${gridBreakpointXLarge})`
};
const useMediaQuery = (values, defaultValue) => {
  // SSR fallback
  if (!canUseDOM || !window.matchMedia) {
    // eslint-disable-line
    return defaultValue;
  }

  // Array containing a media query list for each query
  const mediaQueryLists = Object.keys(queries).map(l => window.matchMedia(queries[l]) // eslint-disable-line
  );

  // Function that gets value based on matching media query
  const getValue = () => {
    // Get index of last media query that matches
    const index = mediaQueryLists.filter(mql => mql.matches).length - 1;
    if (Array.isArray(values)) {
      const valuesArray = convertValuesToFallbackArray(values);
      if (typeof valuesArray[index] !== 'undefined') {
        return valuesArray[index];
      }
    }
    if (typeof values === 'object') {
      // Convert object to array
      const valuesArray = convertValuesObjectToArray(values);
      if (typeof valuesArray[index] !== 'undefined') {
        return valuesArray[index];
      }
    }

    // Return defaultValue if none
    return defaultValue;
  };

  // State and setter for matched value
  const [value, setValue] = useState(getValue);
  useEffect(() => {
    // Event listener callback
    const handler = () => setValue(getValue);
    // Set a listener for each media query with above handler as callback.
    mediaQueryLists.forEach(mql => mql.addListener(handler));
    // Remove listeners on cleanup
    return () => {
      mediaQueryLists.forEach(mql => mql.removeListener(handler));
    };
  }, [] // Empty array ensures effect is only run on mount and unmount
  );

  return value;
};
export default useMediaQuery;